//// Application Packages
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { subtractValuesAdditionalBooleanForm } from '../../functions/form-functions'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    updateFormData,
    updateFormValidity,
    updateFormAuxiliary,
    deleteFormData,
    selectForms,
} from '../../reducers/formSlice'

//// Application Components
import TooltipComponent from '../simple-components/tooltip-component'
import CheckContactFormComponent from '../navigation-components/check-contact-form-component'
import StateSelectorComponent from '../conditional-components/state-selector-component'
import CountySelectorComponent from '../conditional-components/county-selector-component'
import CountrySelectorComponent from '../conditional-components/country-selector-component'
import DividerComponent from '../simple-components/divider-component'

//// Carbon Components
import { TextInput, Button } from '@carbon/react'

//// Carbon Icons
import { Subtract } from '@carbon/icons-react'

//// Static Constants

//////// Component
const AdditionalContactInformationComponent = ({ instance }) => {
    //////// Hooks
    const dispatch = useDispatch()

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']

    //////// Search Params

    //////// Methods

    // Re-Validate Data Submission
    const revalidation = async (event_name) => {
        // Update Validation State
        if (digital_name && event_name) {
            dispatch(
                updateFormValidity({
                    digital_name: digital_name,
                    errors: {
                        [event_name]: false,
                        [event_name + 'ErrMsg']: '',
                    },
                })
            )
        }
    }

    //////// Functional Methods

    // Handle Subtraction Of Contact Form Component
    const handleSubtractContactFormComponent = async () => {
        dispatch(
            updateFormAuxiliary({
                digital_name: digital_name,
                auxiliary: {
                    satellite_location: false,
                },
            })
        )
        const auxiliaries = {
            ...formsData?.[digital_name]?.auxiliary,
            satellite_location: false,
        }
        const values = subtractValuesAdditionalBooleanForm(
            auxiliaries,
            formsData?.[digital_name]?.values
        )
        if (values) {
            dispatch(
                deleteFormData({
                    digital_name: digital_name,
                })
            )
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: values,
                })
            )
        }
    }

    // Handle Data Of All Fields + Integer
    const handleData = (e) => {
        if (e?.target?.name && e?.target?.value) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: {
                        [e.target.name]: e.target.value,
                    },
                })
            )
            revalidation(e.target.name)

            // Cleanup "OUT OF STATE" State
            if (
                e?.target?.name?.includes('cntry_cdeMA') &&
                e?.target?.value !== 'US'
            ) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            ['st_cdeMA']: 'FRG',
                        },
                    })
                )
            } else if (
                e?.target?.name?.includes('cntry_cdePL') &&
                e?.target?.value !== 'US'
            ) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            ['st_cdePL']: 'FRG',
                        },
                    })
                )
            } else if (
                e?.target?.name?.includes('cntry_cdeSL') &&
                e?.target?.value !== 'US'
            ) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            ['st_cdeSL']: 'FRG',
                        },
                    })
                )
            } else if (e?.target?.name?.includes('cntry_cdeMA')) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            ['st_cdeSL']: '',
                        },
                    })
                )
            } else if (e?.target?.name?.includes('cntry_cdePL')) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            ['st_cdeSL']: '',
                        },
                    })
                )
            } else if (e?.target?.name?.includes('cntry_cdeSL')) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            ['st_cdeSL']: '',
                        },
                    })
                )
            }

            // Cleanup "OUT OF STATE" County
            if (
                e?.target?.name?.includes('cntry_cdeMA') &&
                e?.target?.value !== 'US'
            ) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            ['cntyMA']: '825',
                        },
                    })
                )
            } else if (
                e?.target?.name?.includes('cntry_cdePL') &&
                e?.target?.value !== 'US'
            ) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            ['cntyPL']: '825',
                        },
                    })
                )
            } else if (
                e?.target?.name?.includes('cntry_cdeSL') &&
                e?.target?.value !== 'US'
            ) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            ['cntySL']: '825',
                        },
                    })
                )
            } else if (e?.target?.name?.includes('cntry_cdeMA')) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            ['cntyMA']: '',
                        },
                    })
                )
            } else if (e?.target?.name?.includes('cntry_cdePL')) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            ['cntyMA']: '',
                        },
                    })
                )
            } else if (e?.target?.name?.includes('cntry_cdeSL')) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            ['cntyMA']: '',
                        },
                    })
                )
            }
        } else if (e?.target?.name) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: { [e.target.name]: '' },
                })
            )
            revalidation(e.target.name)
        }
        //// Start Watson Assistant Journey

        //// End Watson Assistant Journey
    }

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    if (
        formsData?.[digital_name]?.auxiliary?.practice_location === false &&
        formsData?.[digital_name]?.auxiliary?.satellite_location === false
    ) {
        return (
            <>
                <DividerComponent text="Physical Mailing Address Name:" />

                <TextInput
                    className="required"
                    labelText="Address/PO Box:"
                    id="addr_line1MA"
                    name="addr_line1MA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line1MA}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line1MA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line1MAErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText="APT/Suite:"
                    id="addr_line2MA"
                    name="addr_line2MA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line2MA}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line2MA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line2MAErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText=""
                    id="addr_line3MA"
                    name="addr_line3MA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line3MA}
                    maxLength="40"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line3MA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line3MAErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="ZIP Code:"
                    id="addr_zipMA"
                    name="addr_zipMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_zipMA}
                    maxLength="10"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_zipMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_zipMAErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="City:"
                    id="addr_ctyMA"
                    name="addr_ctyMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_ctyMA}
                    maxLength="20"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_ctyMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_ctyMAErrMsg
                    }
                />

                <CountrySelectorComponent
                    digital_name={digital_name}
                    value_key="cntry_cdeMA"
                    state_value_key="st_cdeMA"
                    county_value_key="cntyMA"
                />

                <StateSelectorComponent
                    instance={instance}
                    digital_name={digital_name}
                    value_key="st_cdeMA"
                    country={formsData?.[digital_name]?.values?.cntry_cdeMA}
                />

                <CountySelectorComponent
                    digital_name={digital_name}
                    value_key="cntyMA"
                    country={formsData?.[digital_name]?.values?.cntry_cdeMA}
                    state={formsData?.[digital_name]?.values?.st_cdeMA}
                />

                <TooltipComponent
                    text="Phone Number Format Guidance"
                    tooltip="(999) 999-9999 or 999-999-9999"
                />

                <TextInput
                    className=""
                    labelText="Phone Number:"
                    id="phne_nbrMA"
                    name="phne_nbrMA"
                    placeholder="(999) 999-9999"
                    value={formsData?.[digital_name]?.values?.phne_nbrMA}
                    maxLength="16"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_nbrMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_nbrMAErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText="Extension:"
                    id="phne_extnMA"
                    name="phne_extnMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.phne_extnMA}
                    maxLength="6"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_extnMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_extnMAErrMsg
                    }
                />

                <TooltipComponent
                    text="Email Notice Guidance"
                    tooltip="If provided, this information will become a public record."
                />

                <TextInput
                    className=""
                    labelText="Email:"
                    id="e_mail_addrMA"
                    name="e_mail_addrMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.e_mail_addrMA}
                    maxLength="100"
                    type="email"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.e_mail_addrMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.e_mail_addrMAErrMsg
                    }
                />

                <DividerComponent text="Physical Location Address:" />

                <CheckContactFormComponent />
            </>
        )
    } else if (
        formsData?.[digital_name]?.auxiliary?.practice_location === true &&
        formsData?.[digital_name]?.auxiliary?.satellite_location === false
    ) {
        return (
            <>
                <DividerComponent text="Mailing Address Name:" />


                <TextInput
                    className="required"
                    labelText="Address/PO Box:"
                    id="addr_line1MA"
                    name="addr_line1MA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line1MA}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line1MA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line1MAErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText="APT/Suite:"
                    id="addr_line2MA"
                    name="addr_line2MA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line2MA}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line2MA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line2MAErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText=""
                    id="addr_line3MA"
                    name="addr_line3MA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line3MA}
                    maxLength="40"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line3MA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line3MAErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="ZIP Code:"
                    id="addr_zipMA"
                    name="addr_zipMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_zipMA}
                    maxLength="10"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_zipMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_zipMAErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="City:"
                    id="addr_ctyMA"
                    name="addr_ctyMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_ctyMA}
                    maxLength="20"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_ctyMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_ctyMAErrMsg
                    }
                />

                <CountrySelectorComponent
                    digital_name={digital_name}
                    value_key="cntry_cdeMA"
                    state_value_key="st_cdeMA"
                    county_value_key="cntyMA"
                />

                <StateSelectorComponent
                    instance={instance}
                    digital_name={digital_name}
                    value_key="st_cdeMA"
                    country={formsData?.[digital_name]?.values?.cntry_cdeMA}
                />

                <CountySelectorComponent
                    digital_name={digital_name}
                    value_key="cntyMA"
                    country={formsData?.[digital_name]?.values?.cntry_cdeMA}
                    state={formsData?.[digital_name]?.values?.st_cdeMA}
                />

                <TooltipComponent
                    text="Phone Number Format Guidance"
                    tooltip="(999) 999-9999 or 999-999-9999"
                />

                <TextInput
                    className=""
                    labelText="Phone Number:"
                    id="phne_nbrMA"
                    name="phne_nbrMA"
                    placeholder="(999) 999-9999"
                    value={formsData?.[digital_name]?.values?.phne_nbrMA}
                    maxLength="16"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_nbrMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_nbrMAErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText="Extension:"
                    id="phne_extnMA"
                    name="phne_extnMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.phne_extnMA}
                    maxLength="6"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_extnMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_extnMAErrMsg
                    }
                />

                <TooltipComponent
                    text="Email Notice Guidance"
                    tooltip="If provided, this information will become a public record."
                />

                <TextInput
                    className=""
                    labelText="Email:"
                    id="e_mail_addrMA"
                    name="e_mail_addrMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.e_mail_addrMA}
                    maxLength="100"
                    type="email"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.e_mail_addrMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.e_mail_addrMAErrMsg
                    }
                />

                <DividerComponent text="Physical Location Address:" />

                <CheckContactFormComponent />

                <TextInput
                    className="required"
                    labelText="Address:"
                    id="addr_line1PL"
                    name="addr_line1PL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line1PL}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line1PL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line1PLErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText=""
                    id="addr_line2PL"
                    name="addr_line2PL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line2PL}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line2PL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line2PLErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText=""
                    id="addr_line3PL"
                    name="addr_line3PL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line3PL}
                    maxLength="40"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line3PL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line3PLErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="ZIP Code:"
                    id="addr_zipPL"
                    name="addr_zipPL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_zipPL}
                    maxLength="10"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_zipPL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_zipPLErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="City:"
                    id="addr_ctyPL"
                    name="addr_ctyPL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_ctyPL}
                    maxLength="20"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_ctyPL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_ctyPLErrMsg
                    }
                />

                <CountrySelectorComponent
                    digital_name={digital_name}
                    value_key="cntry_cdePL"
                    state_value_key="st_cdePL"
                    county_value_key="cntyPL"
                />

                <StateSelectorComponent
                    instance={instance}
                    digital_name={digital_name}
                    value_key="st_cdePL"
                    country={formsData?.[digital_name]?.values?.cntry_cdePL}
                />

                <CountySelectorComponent
                    digital_name={digital_name}
                    value_key="cntyPL"
                    country={formsData?.[digital_name]?.values?.cntry_cdePL}
                    state={formsData?.[digital_name]?.values?.st_cdePL}
                />

                <TooltipComponent
                    text="Phone Number Format Guidance"
                    tooltip="(999) 999-9999 or 999-999-9999"
                />

                <TextInput
                    className=""
                    labelText="Phone Number:"
                    id="phne_nbrPL"
                    name="phne_nbrPL"
                    placeholder="(999) 999-9999"
                    value={formsData?.[digital_name]?.values?.phne_nbrPL}
                    maxLength="16"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_nbrPL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_nbrPLErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText="Extension:"
                    id="phne_extnPL"
                    name="phne_extnPL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.phne_extnPL}
                    maxLength="6"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_extnPL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_extnPLErrMsg
                    }
                />

                <TooltipComponent
                    text="Email Notice Guidance"
                    tooltip="If provided, this information will become a public record."
                />

                <TextInput
                    className=""
                    labelText="Email:"
                    id="e_mail_addrPL"
                    name="e_mail_addrPL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.e_mail_addrPL}
                    maxLength="100"
                    type="email"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.e_mail_addrPL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.e_mail_addrPLErrMsg
                    }
                />
            </>
        )
    } else if (
        formsData?.[digital_name]?.auxiliary?.practice_location === false &&
        formsData?.[digital_name]?.auxiliary?.satellite_location === true
    ) {
        return (
            <>
                <DividerComponent text="Mailing Address Name:" />

                <TextInput
                    className="required"
                    labelText="Address/PO Box:"
                    id="addr_line1MA"
                    name="addr_line1MA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line1MA}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line1MA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line1MAErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText="APT/Suite:"
                    id="addr_line2MA"
                    name="addr_line2MA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line2MA}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line2MA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line2MAErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText=""
                    id="addr_line3MA"
                    name="addr_line3MA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line3MA}
                    maxLength="40"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line3MA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line3MAErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="ZIP Code:"
                    id="addr_zipMA"
                    name="addr_zipMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_zipMA}
                    maxLength="10"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_zipMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_zipMAErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="City:"
                    id="addr_ctyMA"
                    name="addr_ctyMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_ctyMA}
                    maxLength="20"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_ctyMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_ctyMAErrMsg
                    }
                />

                <CountrySelectorComponent
                    digital_name={digital_name}
                    value_key="cntry_cdeMA"
                    state_value_key="st_cdeMA"
                    county_value_key="cntyMA"
                />

                <StateSelectorComponent
                    instance={instance}
                    digital_name={digital_name}
                    value_key="st_cdeMA"
                    country={formsData?.[digital_name]?.values?.cntry_cdeMA}
                />

                <CountySelectorComponent
                    digital_name={digital_name}
                    value_key="cntyMA"
                    country={formsData?.[digital_name]?.values?.cntry_cdeMA}
                    state={formsData?.[digital_name]?.values?.st_cdeMA}
                />

                <TooltipComponent
                    text="Phone Number Format Guidance"
                    tooltip="(999) 999-9999 or 999-999-9999"
                />

                <TextInput
                    className=""
                    labelText="Phone Number:"
                    id="phne_nbrMA"
                    name="phne_nbrMA"
                    placeholder="(999) 999-9999"
                    value={formsData?.[digital_name]?.values?.phne_nbrMA}
                    maxLength="16"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_nbrMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_nbrMAErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText="Extension:"
                    id="phne_extnMA"
                    name="phne_extnMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.phne_extnMA}
                    maxLength="6"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_extnMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_extnMAErrMsg
                    }
                />

                <TooltipComponent
                    text="Email Notice Guidance"
                    tooltip="If provided, this information will become a public record."
                />

                <TextInput
                    className=""
                    labelText="Email:"
                    id="e_mail_addrMA"
                    name="e_mail_addrMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.e_mail_addrMA}
                    maxLength="100"
                    type="email"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.e_mail_addrMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.e_mail_addrMAErrMsg
                    }
                />

                <DividerComponent text="Physical Location Address:" />

                <CheckContactFormComponent />

                <DividerComponent text="Satellite Location Address:" />

                <TextInput
                    className="required"
                    labelText="Address:"
                    id="addr_line1SL"
                    name="addr_line1SL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line1SL}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line1SL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line1SLErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText=""
                    id="addr_line2SL"
                    name="addr_line2SL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line2SL}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line2SL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line2SLErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText=""
                    id="addr_line3SL"
                    name="addr_line3SL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line3SL}
                    maxLength="40"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line3SL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line3SLErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="ZIP Code:"
                    id="addr_zipSL"
                    name="addr_zipSL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_zipSL}
                    maxLength="10"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_zipSL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_zipSLErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="City:"
                    id="addr_ctySL"
                    name="addr_ctySL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_ctySL}
                    maxLength="20"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_ctySL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_ctySLErrMsg
                    }
                />

                <CountrySelectorComponent
                    digital_name={digital_name}
                    value_key="cntry_cdeSL"
                    state_value_key="st_cdeSL"
                    county_value_key="cntySL"
                />

                <StateSelectorComponent
                    instance={instance}
                    digital_name={digital_name}
                    value_key="st_cdeSL"
                    country={formsData?.[digital_name]?.values?.cntry_cdeSL}
                />

                <CountySelectorComponent
                    digital_name={digital_name}
                    value_key="cntySL"
                    country={formsData?.[digital_name]?.values?.cntry_cdeSL}
                    state={formsData?.[digital_name]?.values?.st_cdeSL}
                />

                <TooltipComponent
                    text="Phone Number Format Guidance"
                    tooltip="(999) 999-9999 or 999-999-9999"
                />

                <TextInput
                    className=""
                    labelText="Phone Number:"
                    id="phne_nbrSL"
                    name="phne_nbrSL"
                    placeholder="(999) 999-9999"
                    value={formsData?.[digital_name]?.values?.phne_nbrSL}
                    maxLength="16"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_nbrSL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_nbrSLErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText="Extension:"
                    id="phne_extnSL"
                    name="phne_extnSL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.phne_extnSL}
                    maxLength="6"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_extnSL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_extnSLErrMsg
                    }
                />

                <TooltipComponent
                    text="Email Notice Guidance"
                    tooltip="If provided, this information will become a public record."
                />

                <TextInput
                    className=""
                    labelText="Email:"
                    id="e_mail_addrSL"
                    name="e_mail_addrSL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.e_mail_addrSL}
                    maxLength="100"
                    type="email"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.e_mail_addrSL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.e_mail_addrSLErrMsg
                    }
                />

                <div className="half-width-button-with-icon-group">
                    <div className="half-width-button-with-icon-group-item">
                        <Button
                            className="fldoh-btn"
                            type="button"
                            kind="danger"
                            size="md"
                            onClick={handleSubtractContactFormComponent}
                        >
                            Remove
                            <Subtract />
                        </Button>
                    </div>
                </div>
            </>
        )
    } else if (
        formsData?.[digital_name]?.auxiliary?.practice_location === true &&
        formsData?.[digital_name]?.auxiliary?.satellite_location === true
    ) {
        return (
            <>
                <DividerComponent text="Mailing Address Name:" />

                <TextInput
                    className="required"
                    labelText="Address/PO Box:"
                    id="addr_line1MA"
                    name="addr_line1MA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line1MA}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line1MA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line1MAErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText="APT/Suite:"
                    id="addr_line2MA"
                    name="addr_line2MA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line2MA}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line2MA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line2MAErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText=""
                    id="addr_line3MA"
                    name="addr_line3MA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line3MA}
                    maxLength="40"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line3MA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line3MAErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="ZIP Code:"
                    id="addr_zipMA"
                    name="addr_zipMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_zipMA}
                    maxLength="10"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_zipMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_zipMAErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="City:"
                    id="addr_ctyMA"
                    name="addr_ctyMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_ctyMA}
                    maxLength="20"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_ctyMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_ctyMAErrMsg
                    }
                />

                <CountrySelectorComponent
                    digital_name={digital_name}
                    value_key="cntry_cdeMA"
                    state_value_key="st_cdeMA"
                    county_value_key="cntyMA"
                />

                <StateSelectorComponent
                    instance={instance}
                    digital_name={digital_name}
                    value_key="st_cdeMA"
                    country={formsData?.[digital_name]?.values?.cntry_cdeMA}
                />

                <CountySelectorComponent
                    digital_name={digital_name}
                    value_key="cntyMA"
                    country={formsData?.[digital_name]?.values?.cntry_cdeMA}
                    state={formsData?.[digital_name]?.values?.st_cdeMA}
                />

                <TooltipComponent
                    text="Phone Number Format Guidance"
                    tooltip="(999) 999-9999 or 999-999-9999"
                />

                <TextInput
                    className=""
                    labelText="Phone Number:"
                    id="phne_nbrMA"
                    name="phne_nbrMA"
                    placeholder="(999) 999-9999"
                    value={formsData?.[digital_name]?.values?.phne_nbrMA}
                    maxLength="16"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_nbrMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_nbrMAErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText="Extension:"
                    id="phne_extnMA"
                    name="phne_extnMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.phne_extnMA}
                    maxLength="6"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_extnMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_extnMAErrMsg
                    }
                />

                <TooltipComponent
                    text="Email Notice Guidance"
                    tooltip="If provided, this information will become a public record."
                />

                <TextInput
                    className=""
                    labelText="Email:"
                    id="e_mail_addrMA"
                    name="e_mail_addrMA"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.e_mail_addrMA}
                    maxLength="100"
                    type="email"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.e_mail_addrMA}
                    invalidText={
                        formsData?.[digital_name]?.errors?.e_mail_addrMAErrMsg
                    }
                />

                <DividerComponent text="Physical Location Address:" />

                <CheckContactFormComponent />

                <TextInput
                    className="required"
                    labelText="Address:"
                    id="addr_line1PL"
                    name="addr_line1PL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line1PL}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line1PL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line1PLErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText=""
                    id="addr_line2PL"
                    name="addr_line2PL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line2PL}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line2PL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line2PLErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText=""
                    id="addr_line3PL"
                    name="addr_line3PL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line3PL}
                    maxLength="40"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line3PL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line3PLErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="ZIP Code:"
                    id="addr_zipPL"
                    name="addr_zipPL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_zipPL}
                    maxLength="10"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_zipPL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_zipPLErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="City:"
                    id="addr_ctyPL"
                    name="addr_ctyPL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_ctyPL}
                    maxLength="20"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_ctyPL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_ctyPLErrMsg
                    }
                />

                <CountrySelectorComponent
                    digital_name={digital_name}
                    value_key="cntry_cdePL"
                    state_value_key="st_cdePL"
                    county_value_key="cntyPL"
                />

                <StateSelectorComponent
                    instance={instance}
                    digital_name={digital_name}
                    value_key="st_cdePL"
                    country={formsData?.[digital_name]?.values?.cntry_cdePL}
                />

                <CountySelectorComponent
                    digital_name={digital_name}
                    value_key="cntyPL"
                    country={formsData?.[digital_name]?.values?.cntry_cdePL}
                    state={formsData?.[digital_name]?.values?.st_cdePL}
                />

                <TooltipComponent
                    text="Phone Number Format Guidance"
                    tooltip="(999) 999-9999 or 999-999-9999"
                />

                <TextInput
                    className=""
                    labelText="Phone Number:"
                    id="phne_nbrPL"
                    name="phne_nbrPL"
                    placeholder="(999) 999-9999"
                    value={formsData?.[digital_name]?.values?.phne_nbrPL}
                    maxLength="16"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_nbrPL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_nbrPLErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText="Extension:"
                    id="phne_extnPL"
                    name="phne_extnPL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.phne_extnPL}
                    maxLength="6"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_extnPL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_extnPLErrMsg
                    }
                />

                <TooltipComponent
                    text="Email Notice Guidance"
                    tooltip="If provided, this information will become a public record."
                />

                <TextInput
                    className=""
                    labelText="Email:"
                    id="e_mail_addrPL"
                    name="e_mail_addrPL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.e_mail_addrPL}
                    maxLength="100"
                    type="email"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.e_mail_addrPL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.e_mail_addrPLErrMsg
                    }
                />

                <DividerComponent text="Satellite Location Address:" />

                <TextInput
                    className="required"
                    labelText="Address:"
                    id="addr_line1SL"
                    name="addr_line1SL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line1SL}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line1SL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line1SLErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText=""
                    id="addr_line2SL"
                    name="addr_line2SL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line2SL}
                    maxLength="30"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line2SL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line2SLErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText=""
                    id="addr_line3SL"
                    name="addr_line3SL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_line3SL}
                    maxLength="40"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_line3SL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_line3SLErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="ZIP Code:"
                    id="addr_zipSL"
                    name="addr_zipSL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_zipSL}
                    maxLength="10"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_zipSL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_zipSLErrMsg
                    }
                />

                <TextInput
                    className="required"
                    labelText="City:"
                    id="addr_ctySL"
                    name="addr_ctySL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.addr_ctySL}
                    maxLength="20"
                    type="text"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.addr_ctySL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.addr_ctySLErrMsg
                    }
                />

                <CountrySelectorComponent
                    digital_name={digital_name}
                    value_key="cntry_cdeSL"
                    state_value_key="st_cdeSL"
                    county_value_key="cntySL"
                />

                <StateSelectorComponent
                    instance={instance}
                    digital_name={digital_name}
                    value_key="st_cdeSL"
                    country={formsData?.[digital_name]?.values?.cntry_cdeSL}
                />

                <CountySelectorComponent
                    digital_name={digital_name}
                    value_key="cntySL"
                    country={formsData?.[digital_name]?.values?.cntry_cdeSL}
                    state={formsData?.[digital_name]?.values?.st_cdeSL}
                />

                <TooltipComponent
                    text="Phone Number Format Guidance"
                    tooltip="(999) 999-9999 or 999-999-9999"
                />

                <TextInput
                    className=""
                    labelText="Phone Number:"
                    id="phne_nbrSL"
                    name="phne_nbrSL"
                    placeholder="(999) 999-9999"
                    value={formsData?.[digital_name]?.values?.phne_nbrSL}
                    maxLength="16"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_nbrSL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_nbrSLErrMsg
                    }
                />

                <TextInput
                    className=""
                    labelText="Extension:"
                    id="phne_extnSL"
                    name="phne_extnSL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.phne_extnSL}
                    maxLength="6"
                    type="tel"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.phne_extnSL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.phne_extnSLErrMsg
                    }
                />

                <TooltipComponent
                    text="Email Notice Guidance"
                    tooltip="If provided, this information will become a public record."
                />

                <TextInput
                    className=""
                    labelText="Email:"
                    id="e_mail_addrSL"
                    name="e_mail_addrSL"
                    placeholder=""
                    value={formsData?.[digital_name]?.values?.e_mail_addrSL}
                    maxLength="100"
                    type="email"
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.e_mail_addrSL}
                    invalidText={
                        formsData?.[digital_name]?.errors?.e_mail_addrSLErrMsg
                    }
                />

                <div className="half-width-button-with-icon-group">
                    <div className="half-width-button-with-icon-group-item">
                        <Button
                            className="fldoh-btn"
                            type="button"
                            kind="danger"
                            size="md"
                            onClick={handleSubtractContactFormComponent}
                        >
                            Remove
                            <Subtract />
                        </Button>
                    </div>
                </div>
            </>
        )
    }
}

export default AdditionalContactInformationComponent
